import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '../service/auth';
import { OrganizationService } from '../service/organization';

/**
 * For login (and similar) routes: if already authenticated, go to app home.
 */
export const guestGuard: CanActivateFn = async (): Promise<boolean | UrlTree> => {
  const auth = inject(AuthService);
  const organization = inject(OrganizationService);
  const router = inject(Router);
  if (!auth.isLoggedIn) {
    return true;
  }
  await organization.load();
  return router.createUrlTree([organization.postAuthPath(auth.user())]);
};
